import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { useMedia } from "@/hooks/useMedia";
import { getMemberInfo } from "@/hooks/useMembers";
import type { AvatarContextType } from "@/types/avatar";

const AvatarContext = createContext<AvatarContextType>({
  avatarUrl: null,
  reloadAvatar: async () => {},
});

export const AvatarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const member = getMemberInfo();
  const { getSignedMediaUrl } = useMedia();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);

  const fetchAvatar = useCallback(async () => {
    if (member?.avatar) {
      if (/^https?:\/\//.test(member.avatar)) {
        setAvatarUrl(member.avatar);
      } else {
        const url = await getSignedMediaUrl(member.id, member.avatar);
        setAvatarUrl(url);
      }
    } else {
      setAvatarUrl(null);
    }
  }, [member?.avatar, member?.id, getSignedMediaUrl]);

  useEffect(() => {
    fetchAvatar();
    // Only run on member/avatar change
  }, [fetchAvatar]);

  return (
    <AvatarContext.Provider value={{ avatarUrl, reloadAvatar: fetchAvatar }}>
      {children}
    </AvatarContext.Provider>
  );
};

export const useAvatarContext = () => useContext(AvatarContext);
